/**
 * Imperative bus for ActionToast. Keeps callbacks out of Redux.
 * Mount <ActionToastHost /> once (e.g. in App) so showActionToast works app-wide.
 */

let showHandler = null;
let hideHandler = null;

/**
 * @param {{ show: Function, hide: Function }} handlers
 * @returns {Function} unsubscribe
 */
export function registerActionToastHandlers({ show, hide }) {
  showHandler = show;
  hideHandler = hide;
  return () => {
    if (showHandler === show) {
      showHandler = null;
    }
    if (hideHandler === hide) {
      hideHandler = null;
    }
  };
}

/**
 * @param {object} options
 * @param {string} options.message
 * @param {string} [options.actionLabel]
 * @param {Function} [options.onAction]
 * @param {number} [options.timeout=5000]
 */
export function showActionToast({
  message,
  actionLabel = null,
  onAction = null,
  timeout = 5000,
} = {}) {
  if (!message || typeof showHandler !== 'function') {
    return;
  }
  showHandler({
    message,
    actionLabel,
    onAction,
    timeout,
  });
}

export function hideActionToast() {
  if (typeof hideHandler === 'function') {
    hideHandler();
  }
}
